import { AlertTriangle, MessageSquareText, Star } from "lucide-react";
import { fmtAvg } from "../lib/api";

export const Kpi = ({ label, value, sub, icon: Icon, tone = "default", testId }) => {
  const tones = {
    default: "bg-white border-slate-200/80",
    alert: "bg-[#FEF2F2] border-red-200",
  };
  return (
    <div className={`rounded-2xl border p-5 sm:p-6 ${tones[tone]} card-rise`}>
      <div className="flex items-center justify-between">
        <p className="label-caps">{label}</p>
        {Icon && <Icon className={`w-4 h-4 ${tone === "alert" ? "text-red-600" : "text-[#778580]"}`} />}
      </div>
      <p className={`mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight ${tone === "alert" ? "text-red-600" : "text-[#1A2B25]"}`} data-testid={testId}>
        {value}
      </p>
      {sub && <p className="mt-1 text-xs text-[#778580]">{sub}</p>}
    </div>
  );
};

const Bar = ({ label, value }) => (
  <div>
    <div className="flex justify-between text-sm mb-1.5">
      <span className="text-[#4B5A54]">{label}</span>
      <span className="font-semibold text-[#1A2B25]" data-testid={`category-avg-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{fmtAvg(value)}</span>
    </div>
    <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
      <div className="h-full rounded-full bg-[#2F5D4A] transition-[width] duration-700" style={{ width: `${((value || 0) / 5) * 100}%` }} />
    </div>
  </div>
);

export const StatCards = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
    <Kpi label="Responses" value={stats.total} icon={MessageSquareText} testId="dashboard-total-responses" sub="All time" />
    <Kpi label="Avg rating" value={<span className="inline-flex items-baseline gap-1">{fmtAvg(stats.avg_overall)}<span className="text-base text-[#778580] font-semibold">/5</span></span>} icon={Star} testId="dashboard-avg-rating-value" sub="Overall satisfaction" />
    <div className="col-span-2 lg:col-span-1 rounded-2xl border border-slate-200/80 bg-white p-5 sm:p-6 space-y-3 card-rise" data-testid="dashboard-category-breakdown">
      <p className="label-caps">Categories</p>
      {stats.categories.length ? stats.categories.map((c) => <Bar key={c.label} label={c.label} value={c.avg} />)
        : <p className="text-sm text-[#778580]">No rating categories on this survey.</p>}
    </div>
    <Kpi label="Needs attention" value={stats.flagged} icon={AlertTriangle} tone={stats.flagged ? "alert" : "default"} testId="dashboard-flagged-count" sub="Low reviews not yet addressed" />
  </div>
);
